import React from 'react';
import { Col, Container, Row, Button } from 'reactstrap';
import FormInterview from './components/FormInterview';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import history from '../../history';
import EditFallingRisks from '../../shared/components/EditFallingRisks';
import EditSpecialRequerimets from '../../shared/components/EditSpecialRequerimets';

const Interview = (props) => {
  return (<Container className="dashboard">
    <Row>
      <Col md={12}>
        <h3 className="page-title">Registro Clínico</h3>
        <br />
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'initial', alignItems: 'flex-start' }}>
          <div>
            <Button
              style={{ margin: 0 }}
              color="primary"
              size="sm"
              onClick={() => {
                history.push({
                  pathname: process.env.PUBLIC_URL + '/assitencial/search-clinic-history',
                  state: { 
                    date: props.location.state.dataPatient.fecha,
                    estado_list_form: props.location.state.dataPatient.estado_list_form,
                    pageIndex: props.location.state.pageIndex
                   }
                });
              }}
            >
              <ArrowBackIcon />
            </Button>
          </div>
          <div style={{ marginLeft: 'auto', marginRight: '1em' }}>
            {
              props.location.state.dataPatient.riesgo_caidas !== null && props.location.state.dataPatient.riesgo_caidas !== undefined ?
                <div style={{ marginLeft: 'auto', marginRight: '1em' }}>
                  <div style={{ /* border: '1px solid #55e5bb', */ borderRadius: 50 }}>
                    <EditFallingRisks caidasProps={props.location.state.dataPatient.riesgo_caidas} idAdmision={props.location.state.dataPatient.id_admision} />
                  </div>
                </div>
                : null
            }
          </div>
          <div style={{ marginLeft: '1em', marginRight: '1em' }}>
            {props.location.state.dataPatient.requerimientos_especiales !== null && props.location.state.dataPatient.requerimientos_especiales !== undefined ?
              <div style={{ /* border: '1px solid #55e5bb', */ borderRadius: 50 }}>
                <EditSpecialRequerimets reqEspProps={props.location.state.dataPatient.requerimientos_especiales} idAdmision={props.location.state.dataPatient.id_admision} />
              </div>
              : null}
          </div>
        </div>

      </Col>
    </Row>
    <FormInterview dataPatient={props.location.state.dataPatient} />
  </Container>);
}
export default Interview;